/**
 * Created by ronmarsiano on 15/06/2017.
 */
baseApp.service('UploadFileService', ['$http', function ($http) {
    this.uploadFileToUrl = function (file, uploadUrl,data,onSuccess,onError,onProgress) {
        var formData = new FormData();
        formData.append('file', file);
        if(data)
            formData.append('data',data);

        store.uploadFile({
            onProgress: onProgress,
            method: "POST",
            url: uploadUrl,
            file: formData,
            success: function () {
                if(onSuccess)
                    onSuccess();
            },
            error: function () {
                if(onError)
                    onError();
            }
        });
    };
}
]);



